import { Fragment, useEffect, useState, useCallback } from 'react';
import { Row, Col, Spin, } from 'antd';
import { getConfirmedPrestationsSummary } from '../../../services/reservation';
import { useTranslation } from 'react-i18next';

const DateSummary = ({ queryParams }) => {
   const [loading, setLoading] = useState(false);
   const [batteries, setBatteries] = useState();
   const [exams, setExams] = useState();
   const { t } = useTranslation();
  

   const fetchDateSummaryServices = useCallback(async (params) => {
      if (queryParams.department_id) {
         setLoading(true);
         const response = await getConfirmedPrestationsSummary(params);
         setBatteries([...response.batteries, { 'total_batteries': calcTotalService(response.batteries) }]);
         setExams([...response.exams, { 'total_exams': calcTotalService(response.exams) }]);
         setLoading(false);
      }
   }, []);

   const calcTotalService = (service) => {
      let attended = 0;
      let reserved = 0;
      service.forEach(item => attended = attended + parseInt(item.attended_patients));
      service.forEach(item => reserved = reserved + parseInt(item.reserved_patients));

      return `${attended}/${reserved}`;
   };

   const totalServices = (batteries, exams) => {
      const batteryTotalServices = batteries.filter(battery => battery['total_batteries'])[0]['total_batteries'].split('/');
      const examTotalServices = exams.filter(exam => exam['total_exams'])[0]['total_exams'].split('/');

      return `${parseInt(batteryTotalServices[0]) + parseInt(examTotalServices[0])}/${parseInt(batteryTotalServices[1]) + parseInt(examTotalServices[1])}`;
   };

   useEffect(() => {
      if (queryParams) {
         let params = { ...queryParams };
         delete params['page'];

         fetchDateSummaryServices(params);
      }
   }, [fetchDateSummaryServices]);


   return (
      <Row className="date-summary-wrapper">
         <Col lg={22} xs={24}>
            {
               loading ?
                  <Row justify="center">
                     <Spin className="custom-spinner" />
                  </Row>
                  :
                  batteries && exams &&
                  <Col lg={22} xs={24}>
                     <Row>
                        <Col lg={24}>
                           <h4 className="mb-20">
                            {t('reservations.byDate.confirmedByDate.dateSummary.title')} - {queryParams.department_id === '1' ? 'Salud' : 'Psicología'}
                          </h4>
                        </Col>
                     </Row>
                     <Row justify="space-between">
                        <Col lg={10} xs={24} className="mb-lg-0 mb-md-50 mb-sm-50 mb-xs-50">
                           <Row>
                              <Col lg={18} xs={18}>
                                 <p className="title ml-15 mb-5">
                                  {t('reservations.byDate.confirmedByDate.dateSummary.batteryTitle')}
                                 </p>
                              </Col>
                              <Col lg={5} xs={5}>
                                 <p className="title text-center mb-5">
                                  {t('reservations.byDate.confirmedByDate.dateSummary.totalTitle')}
                                 </p>
                              </Col>
                           </Row>
                           {
                              batteries.map((battery, index) => {
                                 return (
                                    <Row key={index} className={`${index % 2 === 0 && 'gray-row'} pt-5 pb-5`}>
                                       {
                                          battery.name ?
                                             <Fragment>
                                                <Col lg={18} xs={18}>
                                                   <p className="ml-15 mb-0">{battery.name}</p>
                                                </Col>
                                                <Col lg={5} xs={5}>
                                                   <p className="text-center mb-0">{battery.attended_patients}/{battery.reserved_patients}</p>
                                                </Col>
                                             </Fragment>
                                             :
                                             <Fragment>
                                                <Col lg={18} xs={18}>
                                                  <p className="title ml-15 mb-0">
                                                    {t('reservations.byDate.confirmedByDate.dateSummary.totalBatteries')}
                                                  </p>
                                                </Col>
                                                <Col lg={5} xs={5}>
                                                   <p className="title text-center mb-0">{battery.total_batteries}</p>
                                                </Col>
                                             </Fragment>
                                       }
                                    </Row>
                                 )
                              })
                           }
                        </Col>
                        <Col lg={10} xs={24} className="mb-lg-0 mb-md-40 mb-sm-40 mb-xs-40">
                           <Row>
                              <Col lg={18} xs={18}>
                                 <p className="title ml-15 mb-5">
                                  {t('reservations.byDate.confirmedByDate.dateSummary.examTitle')}
                                 </p>
                              </Col>
                              <Col lg={5} xs={5}>
                                 <p className="title text-center mb-5">
                                  {t('reservations.byDate.confirmedByDate.dateSummary.totalTitle')}
                                 </p>
                              </Col>
                           </Row>
                           {
                              exams.map((exam, index) => {
                                 return (
                                    <Row key={index} className={`${index % 2 === 0 && 'gray-row'} pt-5 pb-5`}>
                                       {
                                          exam.name ?
                                             <Fragment>
                                                <Col lg={18} xs={18}>
                                                   <p className="ml-15 mb-0">{exam.name}</p>
                                                </Col>
                                                <Col lg={5} xs={5}>
                                                   <p className="text-center mb-0">{exam.attended_patients}/{exam.reserved_patients}</p>
                                                </Col>
                                             </Fragment>
                                             :
                                             <Fragment>
                                                <Col lg={18} xs={18}>
                                                   <p className="title ml-15 mb-0">
                                                    {t('reservations.byDate.confirmedByDate.dateSummary.totalExams')}
                                                   </p>
                                                </Col>
                                                <Col lg={5} xs={5}>
                                                   <p className="title text-center mb-0">{exam.total_exams}</p>
                                                </Col>
                                             </Fragment>
                                       }
                                    </Row>
                                 )
                              })
                           }
                        </Col>
                     </Row>
                     <Row justify="end" className="gray-row pt-15 pb-15 mt-20">
                        <Col lg={10} xs={24}>
                           <Row>
                              <Col lg={18} xs={18}>
                                 <p className="title ml-15 mb-0">
                                  {t('reservations.byDate.confirmedByDate.dateSummary.totalServices')}
                                 </p>
                              </Col>
                              <Col lg={5} xs={5}>
                                 <p className="title text-center mb-0">{totalServices(batteries, exams)}</p>
                              </Col>
                           </Row>
                        </Col>
                     </Row>
                  </Col>
            }
         </Col>
      </Row>
   );
};

export default DateSummary;